import { TextInput, LoadingOverlay } from "@mantine/core";
import DocumentUpload from "../common/Inputs/DocumentUpload";
import { theme } from "../../theme";

const DocumentUploadModal = ({
  file,
  name,
  setFile,
  setName,
  isRequiredDoc = false,
  isLoading,
}: any) => {
  return (
    <div style={{ position: "relative" }}>
      {/* Overlay */}
      <LoadingOverlay
        visible={isLoading}
        zIndex={1000}
        loaderProps={{ color: theme.colors.brand.normal }}
        overlayProps={{ radius: "sm", blur: 2 }}
        style={{ pointerEvents: "all" }}
      />

      <div style={{ display: "flex", flexDirection: "column", gap: "15px" }}>
        <TextInput
          label="Dosya Adı"
          placeholder="Dosya adı giriniz."
          value={name}
          onChange={(e) => setName(e.currentTarget.value)}
          required
          readOnly={isRequiredDoc} // zorunlu belgelerde readonly
        />
        <DocumentUpload onFileSelect={setFile} />
      </div>
    </div>
  );
};

export default DocumentUploadModal;
